// delete this after migrating back from helena
import { frontendURL } from 'dashboard/helper/URLHelper';

const PatientsHelena = () => import('./PatientsHelena.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/patients-helena'),
    name: 'patients-helena',
    component: PatientsHelena,
    meta: {
      permissions: [],
      public: true,
    },
  },
];
